export const DARK_THEME = "DARK_THEME";
export const SET_DIRECTION = "SET_DIRECTION";
export const CHANGE_THEME = "CHANGE_THEME";
export const GET_THEME_LIST = "GET_THEME_LIST";
export const DEFAULT_THEME = "DEFAULT_THEME";
export const INCREASE_FONT = "INCREASE_FONT";
export const DECREASE_FONT = "DECREASE_FONT";
export const RESET_FONT = "RESET_FONT";
